const API_BASE = (import.meta.env.VITE_API_BASE || 'https://api.gosnel.com').replace(
  /\/$/,
  '',
)

const HUB_TOKEN_KEY = 'gosnel_hub_token_v1'

export function getHubToken() {
  try {
    return sessionStorage.getItem(HUB_TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export function setHubToken(token) {
  try {
    if (token) sessionStorage.setItem(HUB_TOKEN_KEY, token)
    else sessionStorage.removeItem(HUB_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

export function clearHubSession() {
  setHubToken('')
}

async function parseError(res) {
  try {
    const data = await res.json()
    if (data?.detail) {
      if (typeof data.detail === 'string') return data.detail
      if (data.detail.message) return data.detail.message
      if (data.detail.code) return data.detail.code
    }
    return data.message || res.statusText || 'Request failed'
  } catch {
    return res.statusText || 'Request failed'
  }
}

function redirectIfNeighbour(detail) {
  const url =
    (detail && typeof detail === 'object' && detail.redirect_url) ||
    (typeof detail === 'string' && detail.startsWith('http') ? detail : '')
  if (url && typeof window !== 'undefined') {
    window.location.assign(url)
    return true
  }
  return false
}

async function parseErrorDetail(res) {
  try {
    const data = await res.json()
    return data?.detail ?? data
  } catch {
    return null
  }
}

export async function hubResolveEntry(email, intent = 'login') {
  const res = await fetch(`${API_BASE}/api/auth/v2/resolve-entry`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, intent }),
  })
  if (!res.ok) throw new Error(await parseError(res))
  return res.json()
}

export async function hubLogin(email, password) {
  const res = await fetch(`${API_BASE}/api/auth/v2/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  })
  if (!res.ok) {
    const detail = await parseErrorDetail(res)
    if (
      detail &&
      typeof detail === 'object' &&
      detail.code === 'neighbour_redirect' &&
      redirectIfNeighbour(detail)
    ) {
      throw new Error('Redirecting to GoSnel Neighbour…')
    }
    const msg =
      detail == null
        ? res.statusText || 'Request failed'
        : typeof detail === 'string'
          ? detail
          : detail.message || detail.code || res.statusText || 'Request failed'
    throw new Error(msg)
  }
  return res.json()
}

export async function hubOtpRequest(email, purpose = 'login') {
  const res = await fetch(`${API_BASE}/api/auth/v2/otp/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, purpose }),
  })
  if (!res.ok) {
    const detail = await parseErrorDetail(res)
    if (
      detail &&
      typeof detail === 'object' &&
      detail.code === 'neighbour_redirect' &&
      redirectIfNeighbour(detail)
    ) {
      throw new Error('Redirecting to GoSnel Neighbour…')
    }
    const msg =
      detail == null
        ? res.statusText || 'Request failed'
        : typeof detail === 'string'
          ? detail
          : detail.message || detail.code || res.statusText || 'Request failed'
    throw new Error(msg)
  }
  return res.json()
}

export async function hubOtpVerify({ email, otp, purpose = 'login', newPassword }) {
  const body = { email, otp, purpose }
  if (newPassword) body.new_password = newPassword
  const res = await fetch(`${API_BASE}/api/auth/v2/otp/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error(await parseError(res))
  return res.json()
}

export async function hubWorkspaces() {
  const token = getHubToken()
  const res = await fetch(`${API_BASE}/api/auth/v2/workspaces`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error(await parseError(res))
  return res.json()
}

export async function hubExchange(membershipId) {
  const token = getHubToken()
  const res = await fetch(`${API_BASE}/api/auth/v2/exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ membership_id: membershipId }),
  })
  if (!res.ok) throw new Error(await parseError(res))
  return res.json()
}
